import React, { useState } from 'react';
import Sheet from 'react-modal-sheet';

/**
 * Optional guest name (and phone for restaurant) before upload/comment.
 * theme: 'event' = name only; 'restaurant' = name + phone.
 * onSubmit({ guestName, guestPhone }) - both null if "Post as anonymous".
 */
const GuestIdentitySheet = ({ isOpen, onClose, theme, onSubmit }) => {
  const isRestaurant = theme === 'restaurant';
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [postAnonymous, setPostAnonymous] = useState(false);

  const handleSubmit = () => {
    if (postAnonymous) {
      onSubmit({ guestName: null, guestPhone: null });
    } else {
      const guestName = name.trim() || null;
      const guestPhone = isRestaurant ? (phone.trim() || null) : null;
      onSubmit({ guestName, guestPhone });
    }
    setName('');
    setPhone('');
    setPostAnonymous(false);
    onClose();
  };

  const handleCancel = () => {
    setName('');
    setPhone('');
    setPostAnonymous(false);
    onClose();
  };

  const labelName = isRestaurant ? 'Your name (optional)' : 'اسمك (اختياري)';
  const labelPhone = 'Phone (optional)';
  const labelAnonymous = isRestaurant ? 'Post as anonymous' : 'نشر بدون اسم';
  const submitLabel = isRestaurant ? 'Continue' : 'متابعة';

  // Restaurant needs more height (phone field + buttons). Event-only can stay shorter.
  const snapPoints = isRestaurant ? [0.92, 0.72, 0.5] : [0.55, 0.38];

  return (
    <Sheet
      isOpen={isOpen}
      onClose={handleCancel}
      snapPoints={snapPoints}
      initialSnap={0}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content
          style={{
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 20px)',
          }}
        >
          <Sheet.Scroller draggableAt="both">
            <div style={{ padding: 20 }}>
              <p style={{ marginBottom: 16, fontSize: 16, color: '#2c3e50' }}>
                {isRestaurant ? 'How would you like to be shown?' : 'كيف تريد أن يظهر اسمك؟'}
              </p>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: '#555' }}>{labelName}</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={isRestaurant ? 'Name' : 'الاسم'}
                  disabled={postAnonymous}
                  style={inputStyle}
                />
              </div>
              {isRestaurant && (
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: '#555' }}>{labelPhone}</label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone number"
                    disabled={postAnonymous}
                    style={inputStyle}
                  />
                </div>
              )}
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={postAnonymous}
                  onChange={(e) => setPostAnonymous(e.target.checked)}
                />
                <span style={{ fontSize: 14, color: '#555' }}>{labelAnonymous}</span>
              </label>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 12,
                  justifyContent: 'center',
                  paddingBottom: 8,
                }}
              >
                <button type="button" onClick={handleCancel} style={{ ...btnStyle, backgroundColor: '#95a5a6' }}>
                  {isRestaurant ? 'Cancel' : 'إلغاء'}
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{ ...btnStyle, backgroundColor: isRestaurant ? '#166534' : '#2c3e50' }}
                >
                  {submitLabel}
                </button>
              </div>
            </div>
          </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={handleCancel} />
    </Sheet>
  );
};

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: 10,
  border: '2px solid #e0e0e0',
  fontSize: 16,
  outline: 'none',
  boxSizing: 'border-box',
};

const btnStyle = {
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: 10,
  fontSize: 16,
  fontWeight: 600,
  cursor: 'pointer',
  minWidth: '120px',
};

export default GuestIdentitySheet;
